import { render, staticRenderFns } from "./TableServiceDetails.vue?vue&type=template&id=349237b8&scoped=true&"
import script from "./TableServiceDetails.vue?vue&type=script&lang=js&"
export * from "./TableServiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./TableServiceDetails.vue?vue&type=style&index=0&id=349237b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349237b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
